import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
// import { format } from "date-fns";
import "bootstrap/dist/css/bootstrap.min.css";

const AddDrianReports = ({ showModal, handleCloseModal }) => {

    const handleSubmit = () => {
        alert(`Submitted values`);
    };


    return (
        <Modal
            size="lg"
            show={showModal}
            onHide={handleCloseModal}
            className="meeting-modal"  // Custom class for Modal
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="upload-modal-title">Add Drain Report</Modal.Title>
                <div
                    className="position-absolute top-0 end-0 p-3"
                    onClick={handleCloseModal}
                    style={{ cursor: 'pointer' }}
                > <span>&#x2715;</span></div>
            </Modal.Header>
            <Modal.Body>
                <div className="report-form">
                    <div className="row d-flex justify-content-center align-items-center">

                        <div className="container mt-4">
                            <form method="post">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Temperature"
                                                placeholder="Temperature"
                                            />
                                            <label htmlFor="Temperature">Temperature</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="pH"
                                                placeholder="pH"
                                            />
                                            <label htmlFor="pH">pH</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="color"
                                                placeholder="Color (Hazen)"
                                            />
                                            <label htmlFor="color">Color (Hazen)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="tds"
                                                placeholder="TDS (mg/l)"
                                            />
                                            <label htmlFor="tds">TDS (mg/l)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="tss"
                                                placeholder="TSS (mg/l)"
                                            />
                                            <label htmlFor="tss">TSS (mg/l)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Conductivity"
                                                placeholder="Conductivity"
                                            />
                                            <label htmlFor="Conductivity">Conductivity</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="bod"
                                                placeholder="BOD (mg/l)"
                                            />
                                            <label htmlFor="bod">BOD (mg/l)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="cod"
                                                placeholder="COD (mg/l)"
                                            />
                                            <label htmlFor="cod">COD (mg/l)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="tc"
                                                placeholder="TC (MPN/100ml)"
                                            />
                                            <label htmlFor="tc">TC (MPN/100ml)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="fc"
                                                placeholder="FC (MPN/100ml)"
                                            />
                                            <label htmlFor="fc">FC (MPN/100ml)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="nh4_n"
                                                placeholder="NH4-N (mg/l)"
                                            />
                                            <label htmlFor="nh4_n">NH4-N (mg/l)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Nitrate"
                                                placeholder="Nitrate (mg/l)"
                                            />
                                            <label htmlFor="Nitrate">Nitrate (mg/l)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Phosphate"
                                                placeholder="Phosphate (mg/l)"
                                            />
                                            <label htmlFor="Phosphate">Phosphate (mg/l)</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Chloride"
                                                placeholder="Chloride (mg/l)"
                                            />
                                            <label htmlFor="Chloride">Chloride (mg/l)</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="Chromium"
                                                placeholder="Chromium"
                                            />
                                            <label htmlFor="Chromium">Chromium</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <button type="submit" class="submit btn btn-primary">Submit</button>
                                        </div>
                                    </div>
                                    <div className="col-md-3"></div>
                                </div>


                            </form>
                        </div>

                    </div>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default AddDrianReports;
